function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 8V2h2v8H2V8h6zM16 8h6v2h-8V2h2v6zM16 16v6h-2v-8h8v2h-6zM10 16v6H8v-6H2v-2h8v2z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/fullscreen-close.3ec7cc3e.svg";
export { SvgComponent as ReactComponent };